import React, {useEffect, useState} from "react";
import {IItemContent} from "@connox/typescript-library";
import {retrieveBoughtTogether} from "./CrossSelling";
import {useCustomerSelector} from "../../../store";
import {useTranslation} from "react-i18next";
import {localCache} from "./BoughtTogetherPortal";
import SwiperConstruct, {BreakpointType} from "./SwiperConstruct";
import ListItemCard from "../productList/ListItemCard";
import {AddToCartButton} from "../../cart/AddToCartButton/AddToCartButtonPortal";

const BasketModalBoughtTogetherSwiper: React.FC<{itemId: number}> = ({itemId}) => {
  const [items, setItems] = useState<IItemContent[]>([]);
  const {customer} = useCustomerSelector();
  const {t} = useTranslation();

  useEffect(() => {
    if (localCache) {
      setItems(localCache);
    } else {
      void retrieveBoughtTogether(`${itemId}`, customer).then(setItems);
    }
  }, []);

  if (!items.length) {
    return null;
  }

  const breakpoints: BreakpointType = {
    275: {
      slidesPerView: 2.5,
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 0,
    },
  };

  return (
    <SwiperConstruct title={t("product.customersAlsoBought")} breakpoints={breakpoints}>
      {items.map((item, key) => (
        <React.Fragment key={key}>
          <ListItemCard item={item} />
          <AddToCartButton itemId={item.itemId} isSwiperAddToCartButton={true} isModalCartSwiperButton={true} />
        </React.Fragment>
      ))}
    </SwiperConstruct>
  );
};

export default BasketModalBoughtTogetherSwiper;
